export default "__VITE_ASSET__C1aw$0$E__"